import React, { useState } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";

import { CommonLoading } from 'react-loadingg';

import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import background from "../../assets/img/header-background.jpg";

import ReactTooltip from 'react-tooltip';

import {
    Button,
    Collapse,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    NavItem,
    NavLink,
    Nav,
    Progress,
    Table,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
    Tooltip
} from "reactstrap";

import InstanceHeader from "components/Headers/InstanceHeader.js";
import GenericHeader from "components/Headers/GenericHeader.js";
import Accordion from 'react-bootstrap/Accordion';
import Moment from "moment";
import 'moment/locale/el';

const authorityInterventionFeatureEnabled =
    (process.env.REACT_APP_ENABLE_AUTHORITY_INTERVENTION || 'true').toLowerCase() === 'true';

class Instance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            activeNav: 1,
            loading: true,
            instance: [],
            workflow: [],
            user: [],
            logged_user: [],
            steps: [],
            files: [],
            enabled: true,
            fileUpload: null,
            comment: '',
            buttonCondition: 0,
            buttonMessage: '',
            commentDisabled: true,
            isYesSelectedForSupplyContract: false,
            isSupplyContractSent: false,
            showModal: false,
            showSecondModal: false,
            declineMessage: '',
            hasBeenOpened: false,
            replies: [],
            hasReplies: false,
            authorityIntervened: false,
            authorityIntervenedAt: '',
            authorityIntervenedBy: '',
            authorityReply: '',
            authorityReplyDisabled: true,
            authorityInterventionLoading: false,
            authorityInterventionFormVisible: false,
            authorityInterventionMessage: '',
            authorityInterventionMessageDisabled: true,
            authorityInterventionError: '',
            responseDeadline: 10,
        };
        this.authorityInterventionInput = React.createRef();
    }

    async componentDidMount() {
        const handle = this.props.match.params.id;

        await fetch(process.env.REACT_APP_API_LINK + "/api/workflows/response_deadline/", {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .then(res => res.json())
            .then((result) => {
                this.setState({ responseDeadline: result.Duration || 10 });
            })
            .catch(() => {});

        const result = await axios.get(process.env.REACT_APP_API_LINK + "/api/workflowinstances/instance/" + handle + "/", {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
            .then(res => {
                this.setState({
                    instance: res.data.instance,
                    workflow: res.data.workflow,
                    user: res.data.user,
                    logged_user: res.data.logged_user,
                    steps: res.data.stepsInfused,
                    fileUpload: null,
                    comment: '',
                    loading: false,
                    isYesSelectedForSupplyContract: res.data.instance.SupplyContract,
                    hasBeenOpened: res.data.instance.hasBeenOpened,
                    authorityIntervened: !!res.data.instance.AuthorityIntervened,
                    authorityIntervenedAt: res.data.instance.AuthorityIntervenedAt,
                    authorityIntervenedBy: res.data.instance.AuthorityIntervenedBy || ''
                });
                if (!this.state.hasBeenOpened && this.state.instance.Status == 2) {
                    this.setState({ showSecondModal: true });
                }
            })

        const result2 = await axios.get(process.env.REACT_APP_API_LINK + "/api/files/status/" + handle + "/", {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
            .then(res => {
                this.setState({

                    files: res.data
                });
            })

        await fetch(process.env.REACT_APP_API_LINK + "/api/replies/all/" + handle + "/", {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        replies: result.replies,
                        hasReplies: result.hasReplies
                    });

                    if (result.hasReplies) {
                        this.hydrateReplies(result);
                    }
                }
            )
    };

    handleShowModal = () => {
        this.setState({ showModal: true });
    }

    handleJustCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleShowSecondModal = () => {
        this.setState({ showSecondModal: true });
    }

    handleJustCloseSecondModal = () => {
        this.setState({ showSecondModal: false });
    }

    handleCloseSecondModal = () => {
        this.setState({ showSecondModal: false });
        window.location.replace("/consumer/newinstance");
    }

    handleMessageChange = (e) => {
        this.setState({ declineMessage: e.target.value });
    }

    isAuthorityAdmin = () => {
        return this.state.logged_user.PersonRole == 'Admin';
    }

    canStartAuthorityIntervention = () => {
        return authorityInterventionFeatureEnabled
            && this.isAuthorityAdmin()
            && !this.state.authorityIntervened
            && this.state.instance.Completed != true;
    }

    showAuthorityInterventionForm = () => {
        if (!this.canStartAuthorityIntervention()) {
            return;
        }

        this.setState({
            authorityInterventionFormVisible: true,
            authorityInterventionError: ''
        }, () => {
            if (this.authorityInterventionInput.current) {
                this.authorityInterventionInput.current.focus();
            }
        });
    }

    hideAuthorityInterventionForm = () => {
        this.setState({
            authorityInterventionFormVisible: false,
            authorityInterventionMessage: '',
            authorityInterventionMessageDisabled: true,
            authorityInterventionError: ''
        });
    }

    updateAuthorityInterventionMessage = (evt) => {
        this.setState({
            authorityInterventionMessage: evt.target.value,
            authorityInterventionMessageDisabled: evt.target.value.trim() == '',
            authorityInterventionError: ''
        });
    }

    submitAuthorityIntervention = () => {
        if (!this.canStartAuthorityIntervention() || this.state.authorityInterventionMessage.trim() == '') {
            return;
        }

        this.setState({
            authorityInterventionLoading: true,
            authorityInterventionError: ''
        });

        fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/authority_intervention/' + this.state.instance.Id + '/', {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                'Message': this.state.authorityInterventionMessage.trim()
            })
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error('Authority intervention failed');
                }

                return res.json();
            })
            .then((result) => {
                this.setState({
                    authorityIntervened: true,
                    authorityIntervenedAt: result.AuthorityIntervenedAt,
                    authorityIntervenedBy: result.AuthorityIntervenedBy || '',
                    authorityInterventionLoading: false,
                    authorityInterventionFormVisible: false,
                    authorityInterventionMessage: '',
                    authorityInterventionMessageDisabled: true,
                    authorityInterventionError: ''
                });

                fetch(process.env.REACT_APP_API_LINK + "/api/replies/all/" + this.state.instance.Id + "/", {
                    method: 'get',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    })
                })
                    .then(res => res.json())
                    .then((repliesResult) => {
                        this.hydrateReplies(repliesResult);
                    });
            })
            .catch(() => {
                this.setState({
                    authorityInterventionLoading: false,
                    authorityInterventionError: 'Η παρέμβαση δεν υποβλήθηκε. Παρακαλούμε δοκιμάστε ξανά.'
                });
            });
    }

    renderAuthorityInterventionAction = () => {
        if (!this.canStartAuthorityIntervention() || this.state.authorityInterventionFormVisible) {
            return <></>;
        }

        return (
            <Button
                color="warning"
                onClick={(evt) => {
                    evt.stopPropagation();
                    this.showAuthorityInterventionForm();
                }}
                size="sm"
                className="mb-2"
                style={{ width: '100%', whiteSpace: 'normal' }}
            >
                Παρέμβαση Αρχής
            </Button>
        );
    }

    renderAuthorityInterventionInlineForm = () => {
        if (!this.canStartAuthorityIntervention() || !this.state.authorityInterventionFormVisible) {
            return <></>;
        }

        return (
            <div className="alert alert-warning mt-2 mb-0 p-3" role="alert" style={{ textAlign: 'left', width: '100%' }} onClick={evt => evt.stopPropagation()}>
                <h6 className="mb-2" style={{ color: '#8a5a00', fontWeight: '600' }}>Παρέμβαση Αρχής</h6>
                <p className="mb-2">Καταγράψτε το μήνυμα παρέμβασης της Αρχής.</p>
                <Input
                    className="form-control-alternative"
                    innerRef={this.authorityInterventionInput}
                    placeholder="Μήνυμα παρέμβασης της Αρχής"
                    type="textarea"
                    value={this.state.authorityInterventionMessage}
                    onChange={evt => this.updateAuthorityInterventionMessage(evt)}
                />
                {this.state.authorityInterventionError &&
                    <p className="text-danger mb-2 mt-2">{this.state.authorityInterventionError}</p>}
                <div className="d-flex justify-content-end flex-wrap mt-2">
                    <Button
                        color="secondary"
                        onClick={(evt) => {
                            evt.stopPropagation();
                            this.hideAuthorityInterventionForm();
                        }}
                        size="sm"
                        className="mr-2 mb-2"
                        disabled={this.state.authorityInterventionLoading}
                    >
                        Ακύρωση
                    </Button>
                    <Button
                        color="warning"
                        onClick={(evt) => {
                            evt.stopPropagation();
                            this.submitAuthorityIntervention();
                        }}
                        size="sm"
                        className="mb-2"
                        disabled={this.state.authorityInterventionLoading || this.state.authorityInterventionMessageDisabled}
                    >
                        {this.state.authorityInterventionLoading ? 'Περιμένετε...' : 'Υποβολή Παρέμβασης'}
                    </Button>
                </div>
            </div>
        );
    }

    getDeclineModalText = () => {
        if (this.isAuthorityAdmin()) {
            return `Μόλις επιλέξατε να απορρίψετε οριστικά την αναφορά με Α/Α: ${this.state.instance.SerialNumber}. Παρακαλούμε καταγράψτε την αιτία απόρριψης. Ο Καταναλωτής θα ενημερωθεί άμεσα μετά την υποβολή.`;
        }

        return `Μόλις επιλέξατε να υποβάλετε αίτημα απευθείας απόρριψης για την αναφορά με Α/Α: ${this.state.instance.SerialNumber}. Παρακαλούμε καταγράψτε την αιτία ώστε να αποσταλεί προς έλεγχο στην Αρχή. Ο Καταναλωτής θα ενημερωθεί μόνο εφόσον η Αρχή αποδεχθεί το αίτημα απόρριψης.`;
    }

    getDeclineButtonText = () => {
        return this.isAuthorityAdmin() ? 'Απευθείας Απόρριψη Αιτήματος' : 'Αίτημα Απευθείας Απόρριψης';
    }

    getDeclineSubmitText = () => {
        return this.isAuthorityAdmin() ? 'Οριστική Απόρριψη' : 'Υποβολή Αιτήματος Απόρριψης';
    }

    saveInstance = stepStatus => {

        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/update/' + this.state.instance.Id + "/", {
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }),
                body: JSON.stringify(this.state.steps[stepStatus - 1])
            })
                .then(data => {
                })
        }
    }

    approveInstance = stepStatus => {

        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/approve/' + this.state.instance.Id + "/", {
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }),
                body: JSON.stringify(this.state.steps[stepStatus - 1])
            })
                .then(data => {

                    if (stepStatus == 2) {
                        window.location.replace("/admin/details/" + this.state.instance.Id)
                    }
                    else {
                        window.location.reload(false);
                    }

                })
        }
    }

    sendBriefingEmail(instance_id) {
        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/send_briefing_email/' + this.state.instance.Id + '/', {
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                })
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload(false)
                    }
                )

        }
    }

    declineInstance = stepStatus => {

        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/decline/', {
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }),
                body: JSON.stringify({
                    'InstanceId': this.state.instance.Id,
                    'Message': this.state.declineMessage.trim()
                })
            })
                .then(data => {
                    window.location.replace("/admin/details/" + this.state.instance.Id + "/");
                })
        }
    }

    uploadFile(evt, actionid) {
        const formData = new FormData();
        var res = actionid.split("/");

        // Update the formData object 
        formData.append(
            "files",
            evt.target.files[0]
        );


        fetch(
            process.env.REACT_APP_FILEMANAGER_LINK,
            {
                method: 'POST',
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((result) => {

                fetch(process.env.REACT_APP_API_LINK + '/api/files/new/', {
                    method: 'POST',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }),
                    body: JSON.stringify({
                        'Name': result[0].name,
                        'Path': result[0].path,
                        'Size': result[0].size,
                        'Type': result[0].type,
                        'InstanceId': this.state.instance.Id,
                        'StepId': res[0],
                        'ActionId': res[1]
                    })
                })
                    .then(data => {

                        axios.get(process.env.REACT_APP_API_LINK + "/api/files/status/" + this.state.instance.Id + "/", {
                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                        })
                            .then(res => {
                                this.setState({
                                    loading: false,
                                    files: res.data
                                });
                            })
                    })
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    uploadSupplyContractFile(evt, actionId) {
        this.uploadFile(evt, actionId)
        this.setState({ isSupplyContractSent: true })
    }

    updateInputValue(evt) {
        var res = evt.target.id.split("/");
        let data = [...this.state.steps];


        var i;
        for (i = 0; i < (this.state.steps).length; i++) {
            if (this.state.steps[i].step.Id == res[0]) {
                var j;
                for (j = 0; j < (this.state.steps[i].actions).length; j++) {
                    if (this.state.steps[i].actions[j].action.Id == res[1]) {
                        let tempAction = { ...data[i].actions[j] };

                        tempAction.data.Data = evt.target.value;
                        data[i].actions[j] = tempAction;
                        if (tempAction.action.Target == 'Σχόλιο προς καταναλωτή') {
                            if (evt.target.value != '') {
                                this.setState({ commentDisabled: false })
                            }
                            else this.setState({ commentDisabled: true })
                        }

                        this.setState({
                            steps: data
                        });
                    }
                }
            }
        }
    }

    updateComment(evt) {
        this.setState({
            comment: evt.target.value
        });
    }

    updateAuthorityReply(evt) {
        this.setState({
            authorityReply: evt.target.value,
            authorityReplyDisabled: evt.target.value == ''
        });
    }

    hydrateReplies(result) {
        const replies = (result.replies || []).map((reply, index) => ({
            ...reply,
            user: result.users ? result.users[index] : '',
            senderKind: result.senderKinds ? result.senderKinds[index] : ''
        }));

        this.setState({
            replies: replies,
            hasReplies: result.hasReplies
        });
    }

    getReplyStyle(reply) {
        if (reply.senderKind == 'Authority') {
            return {
                textAlign: 'left',
                background: '#fff3cd',
                color: 'black',
                borderRadius: '8px',
                border: '1px solid #ffb84d'
            };
        }

        return {
            textAlign: reply.UserType == 1 ? "left" : "right",
            background: reply.UserType == 1 ? "lightgray" : "powderblue",
            color: "black",
            borderRadius: "8px"
        };
    }

    sendAuthorityReply() {
        fetch(process.env.REACT_APP_API_LINK + '/api/replies/new/', {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }),
            body: JSON.stringify({
                'InstanceId': this.state.instance.Id,
                'UserType': 0,
                'Message': this.state.authorityReply
            })
        })
            .then(() => {
                fetch(process.env.REACT_APP_API_LINK + "/api/replies/all/" + this.state.instance.Id + "/", {
                    method: 'get',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    })
                })
                    .then(res => res.json())
                    .then((result) => {
                        this.hydrateReplies(result);
                        this.setState({
                            authorityReply: '',
                            authorityReplyDisabled: true
                        });
                    })
            })
    }

    renderAuthorityInterventionPanel() {
        const canUseThread = this.state.authorityIntervened || this.state.instance.Status >= 3;
        const canSendThreadReply = !this.state.instance.Completed && this.state.instance.Status != 4;

        if (!canUseThread) {
            return <></>;
        }

        return (
            <Container className="mt-4" fluid>
                <Row>
                    <Col xl="12">
                        <Card className="bg-secondary shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className="mb-0">Παρέμβαση Αρχής / Ανταλλαγή Μηνυμάτων</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.state.authorityIntervened &&
                                    <div className="alert alert-warning" role="alert">
                                        Η Αρχή έχει παρέμβει στο αίτημα
                                        {this.state.authorityIntervenedBy ? ` (${this.state.authorityIntervenedBy})` : ''}.
                                    </div>}

                                {this.state.hasReplies ?
                                    <Col md="12" style={{ height: "32vh", overflowY: "scroll" }}>
                                        {this.state.replies.map((dynamicReplies) =>
                                            <div class="container" style={this.getReplyStyle(dynamicReplies)}>
                                                <strong style={{ margin: "0px" }}>{dynamicReplies.user}</strong>
                                                {dynamicReplies.senderKind == 'Authority' &&
                                                    <p style={{ margin: "0px", fontWeight: "600", color: "#8a5a00" }}>Ρυθμιστική Αρχή Αποβλήτων Ενέργειας και Υδάτων</p>}
                                                <p style={{ margin: "0px" }}>{Moment(dynamicReplies.DateCreated).locale('el').format('DD MMM YYYY HH:mm:ss')}</p>
                                                <h4><i>{dynamicReplies.Message}</i></h4>
                                            </div>
                                        )}
                                    </Col>
                                    :
                                    <p className="text-muted mb-4">Δεν υπάρχουν ακόμη μηνύματα.</p>}

                                {canSendThreadReply &&
                                    <div className="pl-lg-4" style={{ width: '100%' }}>
                                        <h6 className="heading-small text-muted mb-4">
                                            Νέο Σχόλιο προς την Αρχή
                                        </h6>
                                        <Input
                                            className="form-control-alternative"
                                            placeholder="Σχόλιο"
                                            type="textarea"
                                            value={this.state.authorityReply}
                                            onChange={evt => this.updateAuthorityReply(evt)}
                                        />
                                        <br />
                                        <Button
                                            color="success"
                                            onClick={() => this.sendAuthorityReply()}
                                            size="sm"
                                            disabled={this.state.authorityReplyDisabled}
                                        >
                                            Αποστολή
                                        </Button>
                                    </div>}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    deleteFile = fileId => {
        if (window.confirm("Είστε σίγουροι ότι θέλετε να διαγράψετε το συγκεκριμένο αρχείο;") == true) {
            if (localStorage.getItem('token')) {
                axios.delete(process.env.REACT_APP_API_LINK + '/api/files/' + fileId + "/", {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                })
                    .then(res => {
                        axios.get(process.env.REACT_APP_API_LINK + "/api/files/status/" + this.state.instance.Id + "/", {
                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                        })
                            .then(res => {
                                this.setState({
                                    loading: false,
                                    files: res.data
                                });
                            })
                    })
            }
        }
        else { }
    }

    render() {
        const { showModal, declineMessage } = this.state;
        if (this.state.loading) {
            return (
                <>
                    <GenericHeader />
                    <CommonLoading />
                </>
            )
        }
        else {
            return (
                <>
                    <InstanceHeader />
                    {/* <div className="header pb-4" style={{background: "linear-gradient(to right, #FFFFFF, #4A002B)"}}> */}
                    <div className="header pb-4" style={{ backgroundImage: `url(${background})` }}>
                        <Container fluid>
                            <div className="header-body">
                                <Row>
                                    <Col lg="8" xl="12">
                                        <Card className="card-stats mb-4 mb-xl-0">
                                            <CardBody>
                                                <Row>
                                                    <div className="col">
                                                        <CardTitle
                                                            tag="h5"
                                                            className="text-uppercase text-muted mb-0"
                                                        >
                                                        </CardTitle>
                                                        <span className="h2 font-weight-bold mb-0">
                                                            Υποβολή Αιτήματος
                                                        </span>
                                                        <CardBody>
                                                            <Row className="align-items-center"><span style={{ fontWeight: "bold" }}>Α/Α: &nbsp; </span> {this.state.instance.SerialNumber}</Row>
                                                            <Row className="align-items-center"><span style={{ fontWeight: "bold" }}>Ημερομηνία Υποβολής: &nbsp; </span> {Moment(this.state.instance.StartedAt).locale('el').format('dddd, DD MMM YYYY')}</Row>
                                                            <Row className="align-items-center"><br></br></Row>
                                                        </CardBody>
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>

                    {this.renderAuthorityInterventionPanel()}

                    <Accordion defaultActiveKey={this.state.instance.Status}>
                        {this.state.steps.map((dynamicData) =>
                            <Container className="mt-2" fluid>
                                {dynamicData.step.Status < 3 ?
                                    <Row className="mt-5">
                                        <Col className="order-xl-1" xl="12">
                                            <Card className="bg-secondary shadow">
                                                <CardHeader className="bg-white border-0">
                                                    <Accordion.Toggle as={CardHeader} eventKey={dynamicData.step.Status}>
                                                        <Row className="align-items-center">
                                                            <Col xs="8">
                                                                <h3 className="mb-0">{dynamicData.step.Status}. {dynamicData.step.Name}</h3>
                                                                {dynamicData.step.Status < this.state.instance.Status ?
                                                                    <>
                                                                        <p>Υποβλήθηκε {Moment(dynamicData.actions[0].data.DateCreated, "YYYYMMDDhhmm").fromNow()}</p>
                                                                    </> : <></>
                                                                }
                                                            </Col>
                                                            {dynamicData.step.EditPermission.includes(this.state.logged_user.PersonRole) ?
                                                                <>
                                                                    {dynamicData.step.Status == this.state.instance.Status ?
                                                                        <>
                                                                            <Modal isOpen={this.state.showSecondModal} toggle={this.handleJustCloseSecondModal} className="modal-90w" fade={false}>
                                                                                <ModalHeader toggle={this.handleJustCloseSecondModal}></ModalHeader>
                                                                                <ModalBody>
                                                                                    <div>
                                                                                        <p>
                                                                                            Ως πρώτη απάντηση δύναται να χρησιμοποιηθεί η κάτωθι αυτοματοποιημένη απάντηση: "Η αναφορά σας παραλήφθηκε και είναι προς εξέταση" ή να γίνει κανονικά η καταγραφή της απάντησης σας.
                                                                                            Σε περίπτωση επιλογής της αυτοματοποιημένη απάντησης, ο Χρόνος Απόκρισης των {this.state.responseDeadline} εργάσιμων ημερών δεν αναστέλλεται. <span style={{ color: 'red' }}>Τέλος τονίζεται πως αν η καταγραφή της κανονικής απάντησής
                                                                                                σας είναι όμοια με το αυτοματοποιημένο μήνυμα, τότε αυτό θα θεωρηθεί παραπλανητική κίνηση της εταιρείας σας απέναντι στη ΡΑΑΕΥ.</span>
                                                                                        </p>
                                                                                    </div>
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    <Button color="info" onClick={() => this.sendBriefingEmail(this.state.instance.Id)}>
                                                                                        Ενημέρωση μέσω mail
                                                                                    </Button>
                                                                                    <Button color="success" onClick={this.handleJustCloseSecondModal}>
                                                                                        Απάντηση μέσω myRAAEY
                                                                                    </Button>
                                                                                </ModalFooter>
                                                                            </Modal>

                                                                            <Modal isOpen={this.state.showModal} toggle={this.handleJustCloseModal} className="modal-90w" fade={false}>
                                                                                <ModalHeader toggle={this.handleJustCloseModal}></ModalHeader>
                                                                                <ModalBody>
                                                                                    <div>
                                                                                        <p>
                                                                                            {this.getDeclineModalText()}
                                                                                        </p>
                                                                                        <div className="text-muted mb-2">Αιτία απόρριψης</div>
                                                                                        <textarea style={{ width: '450px' }} value={declineMessage} onChange={this.handleMessageChange} />
                                                                                    </div>
                                                                                </ModalBody>
                                                                                <ModalFooter>
                                                                                    <Button disabled={!this.state.declineMessage.trim()} color={this.isAuthorityAdmin() ? 'danger' : 'primary'} onClick={() => { this.declineInstance(dynamicData.step.Status) }}>
                                                                                        {this.getDeclineSubmitText()}
                                                                                    </Button>
                                                                                </ModalFooter>
                                                                            </Modal>
                                                                            <Col className="text-left" xs="12" md="4">
                                                                                {dynamicData.step.Status == 1 ?
                                                                                    <React.Fragment>
                                                                                        <div className="d-flex flex-column align-items-stretch" style={{ width: '100%' }} onClick={evt => evt.stopPropagation()}>
                                                                                            <div className="text-right mb-1">
                                                                                                <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative1'} aria-hidden="true"></i>
                                                                                            </div>
                                                                                            <ReactTooltip id={'info-form-control-alternative1'} type='info'>
                                                                                                <span>Δίνεται η δυνατότητα απόρριψης αιτήματος όταν:</span>
                                                                                                <li>Τα στοιχεία πελάτη είναι λάθος</li>
                                                                                                <li>Τα κοινοποιημένα έγγραφα είναι λανθασμένα</li>
                                                                                                <li>Έχουν αποσταλεί έγγραφα που τυχόν περιέχουν ευαίσθητα προσωπικά δεδομένα τα οποία δεν είναι δεκτικά επεξεργασίας.</li>
                                                                                            </ReactTooltip>
                                                                                            <Button
                                                                                                color="danger"
                                                                                                onClick={this.handleShowModal}
                                                                                                size="sm"
                                                                                                className="mb-2"
                                                                                                style={{ width: '100%', whiteSpace: 'normal' }}
                                                                                            >
                                                                                                {this.getDeclineButtonText()}
                                                                                            </Button>

                                                                                            <Button
                                                                                                color="success"
                                                                                                onClick={() => { this.approveInstance(dynamicData.step.Status) }}
                                                                                                size="sm"
                                                                                                className="mb-2"
                                                                                                style={{ width: '100%', whiteSpace: 'normal' }}
                                                                                            >
                                                                                                Αποδοχή και συνέχεια
                                                                                            </Button>
                                                                                            {this.renderAuthorityInterventionAction()}
                                                                                            {this.renderAuthorityInterventionInlineForm()}
                                                                                        </div>
                                                                                    </React.Fragment>

                                                                                    : <>
                                                                                        <div className="d-flex flex-column align-items-stretch" style={{ width: '100%' }} onClick={evt => evt.stopPropagation()}>
                                                                                            <Button
                                                                                                id="send-answer"
                                                                                                color="success"
                                                                                                onClick={() => { this.approveInstance(dynamicData.step.Status) }}
                                                                                                size="sm"
                                                                                                className="mb-2"
                                                                                                style={{ width: '100%', whiteSpace: 'normal' }}
                                                                                                disabled={this.state.commentDisabled}
                                                                                            >
                                                                                                Αποστολή απάντησης
                                                                                            </Button>
                                                                                            {this.renderAuthorityInterventionAction()}
                                                                                            {this.renderAuthorityInterventionInlineForm()}
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </Col>
                                                                        </> : <> </>
                                                                    }
                                                                </> : <> </>
                                                            }
                                                        </Row>
                                                    </Accordion.Toggle>
                                                </CardHeader>
                                                <Accordion.Collapse eventKey={dynamicData.step.Status}>
                                                    <CardBody>

                                                        <Form id={dynamicData.step.Id} onSubmit={this.handleSubmit}>
                                                            <div className="pl-lg-4">
                                                                <Row>
                                                                    {dynamicData.actions.map((dynamicActions) =>
                                                                        <>
                                                                            <Col lg="12">
                                                                                <FormGroup>
                                                                                    <label
                                                                                        className="form-control-label"
                                                                                        htmlFor="input-username"
                                                                                    >
                                                                                        {dynamicActions.action.Name}
                                                                                    </label>
                                                                                    {dynamicActions.action.Type == 'file' ?
                                                                                        <>
                                                                                            <Row>
                                                                                                <Col lg="10">
                                                                                                    &nbsp;
                                                                                                    <label className="btn btn-primary" htmlFor={dynamicData.step.Id + "/" + dynamicActions.action.Id}>
                                                                                                        Επιλογή αρχείου
                                                                                                    </label>
                                                                                                    <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                    <ReactTooltip id={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                        <span>Μέγιστο μέγεθος αρχείου 5ΜΒ.</span>
                                                                                                        <div id="imageattooltip"></div>
                                                                                                    </ReactTooltip>

                                                                                                    <Input
                                                                                                        className="form-control-alternative"
                                                                                                        // defaultValue={ dynamicActions.data.Data }
                                                                                                        id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                        // placeholder={dynamicActions.action.Description}
                                                                                                        style={{ visibility: "hidden" }}
                                                                                                        type={dynamicActions.action.Type}
                                                                                                        disabled={!dynamicActions.action.Required}
                                                                                                        onChange={evt => this.uploadFile(evt, dynamicData.step.Id + "/" + dynamicActions.action.Id)}
                                                                                                    />
                                                                                                    {(this.state.instance.Status == 2 && this.state.isYesSelectedForSupplyContract == false) &&
                                                                                                        <>
                                                                                                            <CardBody>
                                                                                                                <p style={{ color: 'orange', marginLeft: '-20px', marginTop: '-20px', marginBottom: '-30px' }}><strong>Παρακαλούμε ανεβάστε το αρχείο σύμβασης προμήθειας</strong></p>
                                                                                                            </CardBody>
                                                                                                            <label className="btn btn-primary" htmlFor={dynamicData.step.Id + "/" + dynamicActions.action.Id}>
                                                                                                                Επιλογή αρχείου σύμβασης προμήθειας
                                                                                                            </label>
                                                                                                            <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                            <ReactTooltip id={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                <span>Μέγιστο μέγεθος αρχείου 5ΜΒ.</span>
                                                                                                                <div id="imageattooltip"></div>
                                                                                                            </ReactTooltip>

                                                                                                            <Input
                                                                                                                className="form-control-alternative"
                                                                                                                // defaultValue={ dynamicActions.data.Data }
                                                                                                                id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                // placeholder={dynamicActions.action.Description}
                                                                                                                style={{ visibility: "hidden" }}
                                                                                                                type={dynamicActions.action.Type}
                                                                                                                disabled={!dynamicActions.action.Required}
                                                                                                                onChange={evt => this.uploadSupplyContractFile(evt, dynamicData.step.Id + "/" + dynamicActions.action.Id)}
                                                                                                            />
                                                                                                        </>}

                                                                                                    <Table className="align-items-center table-flush" responsive>
                                                                                                        <thead className="thead-light">
                                                                                                            <tr>
                                                                                                                <th scope="col">Ονομα Αρχειου</th>
                                                                                                                <th scope="col">Ημερομηνια Υποβολης</th>
                                                                                                                <th scope="col">Ενεργειες</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            {
                                                                                                                this.state.files.map((dynamicFiles) =>
                                                                                                                    <>
                                                                                                                        {dynamicActions.action.Id == dynamicFiles.ActionId
                                                                                                                            ?
                                                                                                                            <>
                                                                                                                                <tr>
                                                                                                                                    <td>{dynamicFiles.FileName}</td>
                                                                                                                                    <td>{Moment(dynamicFiles.UploadDate).locale('el').format('dddd, DD MMM YYYY')}</td>
                                                                                                                                    <td>
                                                                                                                                        <Button
                                                                                                                                            color="primary"
                                                                                                                                            href={dynamicFiles.Link}
                                                                                                                                            target="_blank"
                                                                                                                                            size="sm"
                                                                                                                                            title="Προβολή"
                                                                                                                                        >
                                                                                                                                            <i className="fas fa-eye" />
                                                                                                                                        </Button>
                                                                                                                                        <Button
                                                                                                                                            color="danger"
                                                                                                                                            onClick={() => { this.deleteFile(dynamicFiles.Id) }}
                                                                                                                                            size="sm"
                                                                                                                                            title="Διαγραφή"
                                                                                                                                        >
                                                                                                                                            <i className="fas fa-trash" />
                                                                                                                                        </Button>
                                                                                                                                    </td>
                                                                                                                                </tr>
                                                                                                                            </>
                                                                                                                            : <></>
                                                                                                                        }
                                                                                                                    </>
                                                                                                                )

                                                                                                            }
                                                                                                        </tbody>
                                                                                                    </Table>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </>
                                                                                        : <>{dynamicActions.action.Type == 'button' ?
                                                                                            <>
                                                                                                {dynamicData.step.EditPermission.includes(this.state.logged_user.PersonRole) ?
                                                                                                    <>
                                                                                                        <Col lg="6">
                                                                                                            <Button
                                                                                                                color="primary"
                                                                                                                onClick={evt => this.dynamicCall(dynamicActions.action.Target)}
                                                                                                                size="sm"
                                                                                                            >
                                                                                                                {dynamicActions.action.Description}
                                                                                                            </Button>
                                                                                                        </Col>
                                                                                                        {this.state.buttonCondition == dynamicData.step.Status
                                                                                                            ?
                                                                                                            <p>{this.state.buttonMessage}</p>
                                                                                                            : <> {this.state.buttonCondition == 5 ? <p>{this.state.buttonMessage}</p> : <></>} </>
                                                                                                        }
                                                                                                    </> : <> </>
                                                                                                }
                                                                                            </>
                                                                                            : <>
                                                                                                <Input
                                                                                                    className="form-control-alternative"
                                                                                                    defaultValue={dynamicActions.data.Data}
                                                                                                    id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                    placeholder={dynamicActions.action.Description}
                                                                                                    type={dynamicActions.action.Type}
                                                                                                    disabled={dynamicActions.action.Description == 'Σχόλιο προς καταναλωτή' ? false : true}
                                                                                                    onChange={evt => this.updateInputValue(evt)}
                                                                                                />
                                                                                            </>
                                                                                        }
                                                                                        </>
                                                                                    }
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </>
                                                                    )}
                                                                </Row>
                                                            </div>
                                                        </Form>
                                                    </CardBody>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Col>
                                    </Row> : <> </>}
                            </Container>
                        )}
                    </Accordion>
                </>
            );
        }
    }
}

export default Instance;
